<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      title="序列号信息"
      width="1000px"
      @close="$emit('dialog-close', billNo)">
    <Table
        :border="true"
        :stripe="true"
        :columns="columns"
        :data="tableData">
      <template slot="action" slot-scope="{ row, index }">
        <el-button type="danger" @click="handleDelete(row, index)">删除</el-button>
      </template>
    </Table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "SnSerialList",
    data() {
      return {
        dialogVisible: false,
        billNo: "",
        tableData: [],
        columns: [
          {
            title: "序列号",
            key: "serialNo",
            width: 150,
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 150,
          },
          {
            title: "仓库名称",
            key: "warehouseName",
            width: 150,
          },
          {
            title: "仓位名称",
            key: "locationName",
            width: 150,
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(billDetail) {
        this.dialogVisible = true;
        let serials = billDetail.snSerialNos;
        let tableData = [];
        serials.forEach(serial => {
          let tableColum = JSON.parse(JSON.stringify(billDetail));
          tableColum.serialNo = serial.serialNo;
          tableColum.serialId = serial.pkid;
          tableData.push(tableColum);
        });
        this.tableData = tableData;
      },

      handleDelete(row, index) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" })
          .then(() => {
            this.$http.delete("basic","snSerialNos", row.serialId).then(() => {
              this.tableData.splice(index, 1);
              this.$message.success("删除成功");
            });
          });
      },
    },
  };
</script>

<style scoped>

</style>